<template>
  <RevCard
    class="mt-32 p-24 md:p-32"
    :data-test="`payout-${adyenInformation.market}`"
  >
    <div class="flex items-center">
      <Flag class="mr-12" :country-code="adyenInformation.market" size="l" />
      <h2 class="heading-2">
        {{
          i18n(translations.title, {
            market: i18n.country(adyenInformation.market),
          })
        }}
      </h2>
    </div>

    <StatusUnderReview v-if="status === 'UNDER_REVIEW'" class="mt-24" />
    <StatusInformationRequired
      v-else-if="status === 'INFORMATION_REQUIRED'"
      class="mt-24"
    />
    <StatusRejected v-else-if="status === 'REJECTED'" class="mt-24" />
    <StatusVerified v-else-if="status === 'VERIFIED'" class="mt-24" />

    <RevButton
      v-if="!isVerified"
      class="mt-24"
      size="small"
      :to="{
        name: adyenInformation.settingsLink.name,
      }"
      variant="secondary"
    >
      {{ i18n(translations.providePaymentInfos) }}
    </RevButton>
  </RevCard>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { merchantsAPI } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevCard } from '@ds/components/Card'

import StatusInformationRequired from '../Status/StatusInformationRequired/StatusInformationRequired.vue'
import StatusRejected from '../Status/StatusRejected/StatusRejected.vue'
import StatusUnderReview from '../Status/StatusUnderReview/StatusUnderReview.vue'
import StatusVerified from '../Status/StatusVerified/StatusVerified.vue'

import translations from './PayoutMethodAdyen.translations'

const props = defineProps<{
  adyenInformation: merchantsAPI.PaymentAdyenInformation
}>()

const i18n = useI18n()

const status = computed(() => props.adyenInformation.status.code)
const isVerified = computed(() => status.value === 'VERIFIED')
</script>
